<template>
    <v-form
        ref="unitTypeEventActionForm"
        v-model="formValid"
        lazy-validation>                    
            <v-layout wrap>
                <v-flex xs12 px-2>                            
                    <v-text-field
                    v-model="selectedUnitTypeEventAction.name"                     
                    label="Aktienaam"
                    :rules="[formRules.name]"                         
                    required>
                    </v-text-field>
                </v-flex>
                <v-flex xs12 px-2>                            
                    <v-text-field
                    v-model="selectedUnitTypeEventAction.trigger"                     
                    label="Trigger"
                    >
                    </v-text-field>
                </v-flex>                 
                <v-flex xs12 px-2>                   
                    <v-text-field
                    v-model="selectedUnitTypeEventAction.maxOpen"                     
                    label="Maximaal aantal open acties"
                    :rules="[formRules.maxOpen]"                         
                    required>
                    </v-text-field>                                                            
                </v-flex>                                                                
                <v-flex row xs12 wrap>                  
                    <v-layout >
                        <v-btn
                            @click="cancel"                          
                            color=""> 
                            Annuleren
                        </v-btn>                                                                                                         
                        <v-spacer></v-spacer>                                                                          
                        <v-btn                                                
                            color="success"
                            @click="save">
                            Opslaan
                        </v-btn>                        
                    </v-layout>                                                                    
                </v-flex>  
            </v-layout>                                     
        </v-form>    
</template>

<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import _ from 'lodash';

    export default {
        data() {
            return {
                formValid:true,                   
                formRules:{
                    name:(value) => {return (value) ? true : "Veld verplicht"},
                    maxOpen:(value) => {                                                
                        let message = "Veld verplicht en moet een getal zijn"
                        if(!value)
                            return message
                        if(isNaN(value) || (parseInt(value) != value))
                            return message

                        return true                  
                    }
                },
                selectedUnitTypeEventAction:{id:"",name:"", trigger:"", maxOpen:1 }          
            }
        },
        props:{ 
            unitTypeEventId:{
                required:true
            },
            unitTypeEventAction:{
                type:Object
            }
        },
        computed: {
    
        },   
        methods:{
            save(){
                if (this.$refs.unitTypeEventActionForm.validate()) {                    

                    let save                    = {}
                    save.id                     = this.selectedUnitTypeEventAction.id
                    save.name                   = this.selectedUnitTypeEventAction.name
                    save.trigger                = this.selectedUnitTypeEventAction.trigger
                    save.maxOpen                = parseInt(this.selectedUnitTypeEventAction.maxOpen)
                    save.unitTypeEventId        = this.unitTypeEventId
                    
                    
                        
                    this.$store.dispatch(types.SAVE_UNIT_TYPE_EVENT_ACTION, {data:save} ).then((e) => {                                                                   
                          this.selectedUnitTypeEventAction.id = e.id
                          this.$emit('saved', e)
                    });                             
                }                       
            },   
            cancel(){
                this.$emit('cancelClicked')                    
            },                 
            loadForm(){
                if(this.unitTypeEventAction){
                    Object.assign(this.selectedUnitTypeEventAction, this.unitTypeEventAction)                                                    
                }            
            }
        },
        mounted(){        
            this.loadForm()         
        }                    
    }
</script>

<style scoped>

</style>